module.exports = [{
      plugin: require('../node_modules/@prismicio/gatsby-source-prismic-graphql/gatsby-browser.js'),
      options: {"plugins":[],"repositoryName":"lcb-research","defaultLang":"en-us","previews":false,"omitPrismicScript":true,"pages":[{"type":"legislator_orientation","match":"/:uid","component":"C:\\agent\\_work\\5\\s\\LCB\\Research\\LegislatorOrientation\\src\\components\\Orientation\\index.js"}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Legislative Counsel Bureau Research Division - Legislator Training","short_name":"LCB New Legislator Training","start_url":"/","background_color":"#f0f0f0","theme_color":"#30415b","display":"standalone","icon":"src/images/icon.png","icon_options":{"purpose":"maskable"},"cache_busting_mode":"query","include_favicon":true,"legacy":true,"theme_color_in_head":true,"cacheDigest":"ca25395aa6403490a623ab2a4978db8d"},
    },{
      plugin: require('../node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
